import { range } from 'lodash-es';
import { FC } from 'react';

import type { MostViewedResearchItem } from '../model';
import { PopularResearchGrid } from '../presentation/PopularResearch';
import { ResearchItemSkeleton } from './ResearchItemSkeleton';
export const PopularResearchSkeleton: FC<{ count: number; className?: string }> = ({ count, className }) => {
  const data = range(count).map(id => ({ sourceId: `${id}` }) as MostViewedResearchItem);
  return <PopularResearchGrid className={className} data={data} render={() => <ResearchItemSkeleton />} />;
};
